import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const ownedParkingPriceRuleKeys = {
    all: ['ownedParkingPriceRules'],
    get: (filter, scope) => ['ownedParkingPriceRules', filter, scope],
};
export const ownedParkingPriceRuleOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: ownedParkingPriceRuleKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.OwnedParkingPriceRule);
            return repo.get(filter, scope);
        },
    }),
    create: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.OwnedParkingPriceRule);
            return repo.create(requests);
        },
    }),
    update: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.OwnedParkingPriceRule);
            return repo.update(requests);
        },
    }),
    remove: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.OwnedParkingPriceRule);
            return repo.remove(requests);
        },
    }),
    updateAmount: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.OwnedParkingPriceRule);
            return repo.updateAmount(request);
        },
    }),
};
